<template>
  <div class="leaderboard-title">
    <span>
      <aha-icon
        name="trophy-outlined"
        class="-mt-2"
        width="36"
        height="36"
        viewBox="0 0 24 24"
      ></aha-icon>
    </span>
    <span>
      {{ $i18nPresenter.t('Leaderboard') }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'LeaderboardTitle',
}
</script>

<style lang="scss" scoped>
.leaderboard-title {
  margin: 0 auto;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
}
</style>
